/**
 * @hidden
 */
export function getDefaultSlots(component) {
    var defaultSlots = component.$slots.default;
    return (component.v3 && defaultSlots && typeof defaultSlots === 'function') ? defaultSlots() : defaultSlots;
}



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-common/dist/es/defaultSlots.js
// module id = 354
// module chunks = 93